import styled from 'styled-components';
import { Body2, colors, spacing, smallShadow } from 'ui/theme';

export const StyledContentCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.plusHalf};
  border-radius: ${spacing.half};
  background-color: ${colors.backgroundPrimary};
  gap: ${spacing.plusHalf};
  ${smallShadow};
`;

export const MarginlessBody2 = styled(Body2)`
  margin: 0;
`;

export const MarginlessBody2Bold = styled(Body2)`
  margin: 0;
`;
